import {useNavigate} from "react-router-dom";
import {ArrowLeft} from "react-bootstrap-icons";
import React from "react";

import "./BackButton.css";

export function BackButton() {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <button className="btn btn-link back-button" onClick={handleBackClick}>
            <ArrowLeft className="arrow-icon"/>
        </button>
    );
}